module.exports = __webpack_public_path__ + "52d8032743bd6d6b249a7d74a3096c7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/team/Leadership_Justin_1.jpg
// module id = 394
// module chunks = 0